
<div
    v-if="unit"
    :class="compact ? 'doc-panel-compact' : 'doc-panel'"
>
    <div
        class      = "v-flex mb-0 white"
        @dragover  = "onDragover"
        @dragleave = "onDragleave"
        @drop      = "onDrop"
    >
        <div style="display: block" >
            <div class="pt-3 doc-header v-flex">
                <div>
                    {{ $t("dms.upload.title") }}
                </div>
                <v-switch
                    v-if    = "!compact"
                    v-model = "all"
                    style   = "margin-top: 1px;"
                    :label  = "all ? $t('dms.assign.all') : $t('dms.assign.unit', [ unit.fabricNo ])"
                    class   = "pt-0 ml-2"
                    :ripple = "false"
                    @change = "onAll"
                    hide-details
                />
            </div>
            <div class="step-name">
                {{ stepName}}
            </div>
        </div>

        <v-spacer />
        <div class="mt-1">
            <input
                v-model = "search"
                class   = "lm-border search-field"
                @input  = "onSearch"
            />
        </div>
        <div class="text-center mt-3 mr-3 ml-2">
            <v-icon class="primary--text" size="32">mdi-cloud-upload</v-icon>
        </div>
    </div>

    <div v-if="isDragging" class="w-100 text-center primary--text">
        {{ $t("dms.upload.mousehint") }}
    </div>

    <div :class="compact ? 'doc-panel-compact' : 'doc-panel'">
        <p-dms-entries
            :step-data-id = stepDataId
            :category     = "category"
            :documents    = "documents"
            :compact      = "compact"
        />
    </div>
</div>
